import { RELATION_MEMBER_OF, UserEntity } from '@mainstage/catalog-model';
import { getEntityRelations, useEntity } from '@mainstage/plugin-catalog-react';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';
import { Alert } from '@material-ui/lab';
import { LinksGroup } from '../LinksGroup';
import {
  WbCard,
  WbCardContent,
  WbAvatar,
  WbEntityRefLinks,
  WbInfoTooltip,
  WbLink,
} from '@agilelab/plugin-wb-platform';
import { InvalidateUserTokensButton } from './InvalidateUserTokensButton';

/**
 * Exported publicly via the EntityUserProfileCard
 */
export function UserProfileCard() {
  const { entity: user } = useEntity<UserEntity>();

  if (!user) {
    return <Alert severity="error">User not found</Alert>;
  }

  const {
    metadata: { name: metaName, links },
    spec: { profile },
  } = user;
  const resolvedDisplayName = profile?.displayName ?? metaName;
  const emailHref = profile?.email ? `mailto:${profile.email}` : undefined;
  const memberOfRelations = getEntityRelations(user, RELATION_MEMBER_OF, {
    kind: 'Group',
  });

  return (
    <WbCard
      cardStyle={{ height: '100%' }}
      headerStyle={{
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '16px',
      }}
      headerContentStyle={{
        width: 'auto',
        flex: 1,
        minWidth: 0,
      }}
      title={resolvedDisplayName}
      leading={<PersonIcon />}
      actions={<InvalidateUserTokensButton user={user} />}
    >
      <WbCardContent>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12} sm={2} xl={1}>
            <WbAvatar
              displayName={resolvedDisplayName}
              picture={profile?.picture}
            />
          </Grid>

          <Grid item md={10} xl={11}>
            <List>
              {profile?.email && (
                <ListItem>
                  <ListItemIcon>
                    <WbInfoTooltip title="Email" icon={<EmailIcon />} />
                  </ListItemIcon>
                  <ListItemText>
                    <WbLink to={emailHref ?? ''}>{profile.email}</WbLink>
                  </ListItemText>
                </ListItem>
              )}

              <ListItem>
                <ListItemIcon>
                  <WbInfoTooltip title="Member of" icon={<GroupIcon />} />
                </ListItemIcon>
                <ListItemText>
                  <WbEntityRefLinks
                    entityRefs={memberOfRelations}
                    defaultKind="Group"
                  />
                </ListItemText>
              </ListItem>

              <LinksGroup links={links} />
            </List>
          </Grid>
        </Grid>
      </WbCardContent>
    </WbCard>
  );
}
